export default __webpack_public_path__ + "static/media/tabs.9e5fa833.png";